import React from "react";
import classNames from "classnames";

const TableActions = ({ children, customClasses, gridActions, gridTitle }) => {
  return (
    <ul
      className={classNames(
        customClasses,
        gridActions
          ? "lms-grid-actions my-2 d-flex justify-content-center text-center"
          : "lms-table-actions justify-content-center text-center",
        gridTitle ? "lms-grid-header d-flex justify-content-center text-center my-auto" : ""
      )}
    >
      {children}
    </ul>
  );
};

export default TableActions;
